import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'

const MailIcon: React.FC = () => (
    <SvgIcon fontSize='small' viewBox='0 0 21 20'>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M10.5 3.125L3 8.125V16.25C3 16.5952 3.27982 16.875 3.625 16.875H17.375C17.7202 16.875 18 16.5952 18 16.25V8.125L10.5 3.125ZM4.25 8.56771L10.5 4.27083L16.75 8.56771L10.5 12.8646L4.25 8.56771Z'
            fill='#C7CAD4'
        />
    </SvgIcon>
)
export default MailIcon
